import { render, staticRenderFns } from "./cartridge-batch-add.vue?vue&type=template&id=4d0daa91&"
import script from "./cartridge-batch-add.vue?vue&type=script&lang=js&"
export * from "./cartridge-batch-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d0daa91')) {
      api.createRecord('4d0daa91', component.options)
    } else {
      api.reload('4d0daa91', component.options)
    }
    module.hot.accept("./cartridge-batch-add.vue?vue&type=template&id=4d0daa91&", function () {
      api.rerender('4d0daa91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/production-manage/cartridge-batch/cartridge-batch-add.vue"
export default component.exports